import moment, { Moment } from 'moment';
import { datePickerFormat, dateFormat } from '@/constants';

export default (date: string) => {
  const DATE = moment(date, [datePickerFormat, moment.ISO_8601]);
  if (!DATE.isValid()) {
    return date;
  }
  return DATE.format(dateFormat);
};
